import { render, staticRenderFns } from "./NuevoTalonario.vue?vue&type=template&id=e3a15a74"
import script from "./NuevoTalonario.vue?vue&type=script&lang=js"
export * from "./NuevoTalonario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports